import {post_} from './request.js';
import router from '@/router';


// 配置信息
export function settingInfo_(callback, reflash) {

    if (!reflash) {
        if (window.localStorage.getItem('settingInfo')) {
            callback(JSON.parse(window.localStorage.getItem('settingInfo')));
            return;
        }
    }
    post_('api/sys-setting/info', {}, (res) => {
       window.localStorage.setItem('settingInfo', JSON.stringify(res));
       callback(res);

   });

 }

// 导航
export function categoryTree_(callback, reflash) {
    if (!reflash) {
       if (window.localStorage.getItem('categoryTree')) {
           callback(JSON.parse(window.localStorage.getItem('categoryTree')));
           return;
       }
   }
    post_('api/cms-category/top-category-tree', {}, (res) => {
        window.localStorage.setItem('categoryTree', JSON.stringify(res));
        callback(res);
   })
}


export function goCate_(item) {
    if (item == 'home') {
        this.$router.push({path:'/'});
    }

    // 产品中心
    let id = item.id;
    if (id == 36 || id == 37) {
        id = 39;
    }
    if (id == 38) {
        id = 42;
    }

    // 产品中心
    if (id == 39 || id == 40 || id == 41) {
        router.push({path:'/product', query:{cateId:id}});
    }
    if (id == 42 || id == 43 || id == 44) {
        router.push({path:'/product2', query:{cateId:id}});
    }
    // 用户案例
    if (id == 45) {
        router.push({path:'/case', query:{cateId:id}});
    }
   // 关于我们
   if (id == 46) {
       router.push({path:'/about', query:{cateId:id}});
   }
   // 知识分享
   if (id == 47) {
       router.push({path:'/article', query:{cateId:id}});
   }
   // 伙伴聘请
   if (id == 48) {
       router.push({path:'/partner', query:{cateId:id}});
   }
}

export function goAdv_(item) {
    if (item.advUrl) {
        window.open(item.advUrl);
    }
}

export function goLink_(item) {
    if (item.url) {
        window.open(item.url);
    }
}

export function goSearch_() {
    router.push({path:'/search', query:{}});
}
